import { useState } from "react";
import { motion } from "framer-motion";
import { CheckoutDialog } from "@/components/CheckoutDialog";
import { track } from "@/lib/analytics";
import { Seo } from "@/components/Seo";
import { PAGE_SEO, breadcrumbLd } from "@/lib/seo";
import { Check } from "lucide-react";

const INCLUDES = [
  "A standing room calendar. Dinners and working sessions through the year.",
  "A direct line to introductions worth making.",
  "The Operating Room archive, in full.",
  "Priority on workshops and retreats.",
];

export default function TheTablePublic() {
  const [open, setOpen] = useState(false);
  return (
    <div className="exec-scope min-h-screen" data-testid="the-table-page">
      <Seo {...PAGE_SEO.theTable} jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "The Table", path: "/the-table" }])} />
      <section className="exec-container pt-24 md:pt-28 pb-10">
        <div className="max-w-[820px]">
          <p className="exec-eyebrow">Membership</p>
          <h1 className="font-extralight text-[clamp(34px,4.8vw,60px)] leading-[1.1] mt-6">The Table.</h1>
          <p className="exec-serif text-[clamp(18px,2vw,23px)] leading-[1.5] text-[color:var(--lead-ink)] mt-6">
            The room for operators who want senior judgment on standing call. One annual membership. A seat at the table.
          </p>
        </div>
      </section>

      <section className="exec-container pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <ul className="space-y-5">
              {INCLUDES.map((t, i) => (
                <motion.li key={i} initial={{ opacity: 0, y: 8 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="flex items-start gap-3">
                  <Check size={18} className="text-[color:var(--copper-deep)] mt-1 shrink-0" />
                  <span className="exec-serif text-[17px] leading-[1.5] text-[color:var(--lead-ink)]">{t}</span>
                </motion.li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-5">
            <div className="exec-card p-8">
              <div className="flex items-baseline justify-between">
                <span className="exec-eyebrow">Annual</span>
                <span className="font-extralight text-[34px] leading-none">$2,800</span>
              </div>
              <p className="exec-serif text-[15.5px] text-[color:var(--lead-ink)] mt-3">Billed yearly. Cancel anytime from the billing portal.</p>
              <button data-testid="table-join-button" className="exec-btn exec-btn-primary w-full mt-7" onClick={() => { track("door_click", { target: "membership", location: "the_table" }); setOpen(true); }}>
                Join The Table
              </button>
            </div>
          </div>
        </div>
      </section>

      <CheckoutDialog open={open} onOpenChange={setOpen} productKey="the-table-membership" title="The Table Annual Membership" priceLabel="$2,800 per year" kicker="Membership" />
    </div>
  );
}
